import { gql } from "@apollo/client";

import { PROMO_CODE_FRAGMENT } from "@graphql/fragments";

export const PROMOTIONAL_DOLLAR_QUERY = gql`
  ${PROMO_CODE_FRAGMENT}

  query promotionalDollarQuery {
    promotionalDollarBalanceInCents
    userPromotionCodeRedemptions {
      id
      status
      promotionCode {
        ...PromoCodeFragment
      }
    }
  }
`;

export const USER_REFERRAL_DATA = gql`
  query userReferralData {
    userReferralData {
      referralUrl
      referralAmountInCents
      inviteText
      earnedBonusInCents
      pendingBonusInCents
      referrals {
        firstName
        lastName
        signedUpAt
        activatedAt
        contributedAt
        status
      }
    }
  }
`;
